import { Autocomplete, Grid, TextField } from '@mui/material';
import { Roles, UsersType } from '../../module/contacts/conf/Data.conf';

const UserTypeAndCrewResponsabilitySelector = ({
  userTypeSelect,
  crewResponsability,
  onChangeCrewResponsability,
  disableCrewResponsability = false
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ display: 'none' }}>
        <Autocomplete
          disablePortal
          options={UsersType}
          isOptionEqualToValue={(option, value) =>
            option.label === value.label
          }
          getOptionLabel={(option) => option?.label || ''}
          value={userTypeSelect}
          disabled
          renderInput={(params) => (
            <TextField {...params} label='User Type' />
          )}
        />
      </Grid>
      {userTypeSelect?.id === 'Crew' && (
        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            options={Roles}
            disabled={disableCrewResponsability}
            isOptionEqualToValue={(option, value) =>
              option.label === value.label
            }
            onChange={(_, newValue) => {
              onChangeCrewResponsability(newValue);
            }}
            getOptionLabel={(option) => option?.label || ''}
            value={crewResponsability}
            renderInput={(params) => (
              <TextField {...params} label='Crew Responsability' />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default UserTypeAndCrewResponsabilitySelector;